@switch (action().type) {
  @case (TableItemActionType.Command) {
    <p-button
      (onClick)="action().command!(this.model())"
      [pTooltip]="action().tooltip"
      [text]="true"
      appPrimengButton
      tooltipPosition="left">
      <app-icon [icon]="action().icon" />
    </p-button>
  }
  @case (TableItemActionType.RouterLink) {
    <a
      [routerLink]="action().routerLink!(this.model())"
      [queryParams]="queryParams()"
      [target]="action().target!">
      <p-button
        [pTooltip]="action().tooltip"
        [text]="true"
        appPrimengButton
        tabindex="-1"
        tooltipPosition="left">
        <app-icon [icon]="action().icon" />
      </p-button>
    </a>
  }
  @case (TableItemActionType.Url) {
    <a
      [href]="action().url!(this.model())"
      [target]="action().target!">
      <p-button
        [pTooltip]="action().tooltip"
        [text]="true"
        appPrimengButton
        tabindex="-1"
        tooltipPosition="left">
        <app-icon [icon]="action().icon" />
      </p-button>
    </a>
  }
  @case (TableItemActionType.More) {
    <p-button
      (onClick)="handleMoreClick($event)"
      [pTooltip]="action().tooltip"
      [text]="true"
      appPrimengButton
      tooltipPosition="left">
      <app-icon [icon]="action().icon" />
    </p-button>
  }
  @default {
    Nieznany typ "{{ action().type }}".
  }
}

<p-menu
  [style]="{ width: '15rem' }"
  [model]="
    action().children
      | onlyVisibleTableItemActions: model()
      | itemActionSubmenuItems: model()
  "
  [popup]="true" />
